import { mailEventEmitter } from 'mini-mail-event-emitters';
import { useEffect } from 'react';
/**
 * Triggers functions for a event emitter
 * @param mutableState - State whose change recalcutes the callback function
 */
export const useEventEmitter = (
    callback: (conversationID?: string) => void,
    eventName: string,
    mutableState?: number
) => {
    useEffect(() => {
        mailEventEmitter.on(eventName, callback);

        return () => {
            mailEventEmitter.off(eventName, callback);
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has a missing dependency: 'callback'. Either include it or remove the dependency array. */
    }, [mutableState]);
};
